export default {"src":"https://fishbrain.com/_next/static/media/mississippi.eda78f00.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};